import { lazy, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CREATE_QUOTE_URL } from "../../apiConfig";
import { getLocalData, setLocalData } from "../../../Utilities/Common/source";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";
import { decrypt, encrypt } from "../../../Utilities/utils";
import { CIS_FORM_CONFIRMATION_PAGE_ROUTE } from "../../routes";

const ProposerDetailsForm = lazy(() =>
  import("./Components/ProposerForm/ProposerDetailsForm")
);
const InsuredsDetailsForm = lazy(() =>
  import("./Components/InsuredForm/InsuredsDetailsForm")
);
const NomineeDetailsForm = lazy(() =>
  import("./Components/NomineeForm/NomineeDetailsForm")
);
const MedicalQuestionnaire = lazy(() =>
  import("./Components/MedicalForm/MedicalQuestionnaireForm")
);

const useOptimaSecureCQ = ({ transferData, transferDataId }) => {
  const localSource = getLocalData("source");
  console.log("uOSCQ localSource: ", localSource);
  const steps = [
    ProposerDetailsForm,
    InsuredsDetailsForm,
    MedicalQuestionnaire,
    NomineeDetailsForm,
  ];

  const stepsLabel = ["Proposer", "Insureds", "Medical", "Nominee"]; // label for the steps/tabs

  const navigate = useNavigate();
  const [finalData, setFinalData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const [loading, setLoading] = useState(false);

  const { transferDataId: encryptedTransferDataId } = useParams();
  console.log("transferDataId", transferDataId);
  console.log("encryptedTransferDataId", encryptedTransferDataId);

  // Function to check if saved data exists and show snackbar
  useEffect(() => {
    getFormDataFromLocalStorage();
  }, [transferDataId]);

  const onSubmit = async (data) => {
    setFinalData((prevData) => ({ ...prevData, ...data }));
    // saving data to local storage
    const currentData = { ...finalData, ...data };
    setFormDataToLocalStorage(currentData);

    if (activeStep < steps.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
      window.scrollTo(0, 0);
      return;
    }

    // Send form data to the server
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `${CREATE_QUOTE_URL}/${transferData.A_id}/${transferDataId}/`,
        JSON.stringify({ ...finalData, ...data }),
        {
          params: {
            source: localSource,
          },
        }
      );
      setLoading(false);
      console.log("hdfcOptimaSecureReqBody response: ", response?.data);
      if (response.status === 200) {
        localStorage.removeItem(`_cq_form-${encryptedTransferDataId}`);
        navigate(`${CIS_FORM_CONFIRMATION_PAGE_ROUTE}/${transferDataId}`, {
          state: {
            transferData: transferData,
          },
        });
      }
      //we need to define route in App.js and navigate it to the CISForm.jsx
      // navigate(`/health-insurance/cis-form/optima-secure/`);
    } catch (error) {
      console.log("error: ", error?.response?.data);
      console.log("error JSON: ", JSON.stringify(error?.response?.data));
      setLoading(false);
      alert(
        error?.response?.data?.Error ?? JSON.stringify(error?.response?.data)
      );
    }
  };

  const onBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevStep) => prevStep - 1);
    } else {
      navigate(-1);
    }
  };

  // saving form state to local storage
  const setFormDataToLocalStorage = (formData) => {
    try {
      const key = `_cq_form-${encryptedTransferDataId}`;
      const dataWithTimestamp = { ...formData, timestamp: Date.now() };
      setLocalData(key, encrypt(JSON.stringify(dataWithTimestamp)));
    } catch (error) {
      console.error("error", error);
    }
  };

  // getting form data from local storage and set as default values in form
  const getFormDataFromLocalStorage = () => {
    try {
      const key = `_cq_form-${encryptedTransferDataId}`;
      const savedData = getLocalData(key);
      if (savedData) {
        let formData = decrypt(savedData);
        formData = JSON.parse(formData);
        console.log("form data from local storage", formData);
        setFinalData(formData);
      }
    } catch (error) {
      console.error("getFormDataFromLocalStorage error", error);
    }
  };

  console.log("finalData: ", finalData);

  const CurrentStep = steps[activeStep];

  /**
   * Handles the click event on tabs/steps of the stepper.
   *
   * @param {number} index - The index of the clicked step/tab.
   * @returns {void}
   */
  const handleStepClick = (index) => {
    // Ensure index is within valid range and not ahead of the active step
    if (index < 0 || index > steps.length - 1 || index >= activeStep) return;

    // Set the active step to the clicked index
    setActiveStep(index);
  };

  return {
    transferData,
    onBack,
    onSubmit,
    finalData,
    loading,
    CurrentStep,
    stepsLabel,
    activeStep,
    handleStepClick,
  };
};

export default useOptimaSecureCQ;
